import styled from 'styled-components';
import { Translate } from 'react-redux-i18n';
import { hexToRgba } from '../../../../utils/style';
import { StyleColor, BaseStyledComponentProps } from '../../../../utils/styles-constants';

interface StyledTagProps extends BaseStyledComponentProps {
	isActive: boolean;
}

const StyledTag = styled('button').attrs({
	type: 'button',
})`
	box-sizing: border-box;
	min-width: 60px;
	margin: 0 10px 10px 0;
	padding: 10px 20px;
	border: 0;
	border-radius: 20px;
	outline: 0;
	font-size: 14px;
	line-height: 16px;
	background-color: ${StyleColor.Grey50};
	color: ${(props: StyledTagProps) => props.theme.primary.actionColor};
	cursor: pointer;
	transition: background-color 0.2s, color 0.2s;
	white-space: nowrap;

	${({ isActive, theme }: StyledTagProps) => isActive && `
		background-color: ${theme.primary.actionColor};
		color: ${StyleColor.White};
	`}
`;

const StyledLabel = styled(Translate)`
	display: block;
	margin: 20px 0;
	font-size: 14px;
	line-height: 16px;
	color: ${(props: BaseStyledComponentProps) => hexToRgba(props.theme.primary.strongColor, 50)};
`;

const StyledTagsList = styled('ul')`
	display: flex;
	flex-wrap: wrap;
	max-height: 138px;
	margin: 0;
	padding: 0;
	list-style-type: none;
	overflow-x: hidden;
	overflow-y: auto;
`;

export {
	StyledTag,
	StyledLabel,
	StyledTagsList,
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/DriveItemList/Search/TagsList/styles.ts